module.exports = __webpack_public_path__ + "static/media/hexa.5bc1f882.svg";